import React, { useState } from 'react';
import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import {
  sendMessage,
  getSubmission,
} from 'store/entities/submissionDetail/thunks';
import { editorConfig } from './config';

import RichTextEditor from 'react-rte';

import Button from 'components/UIComponents/Button';
import './style.scss';

export default () => {
  const { submissionId } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { userDetails } = useSelector(state => state.auth);
  const { sendMessageSubmitting } = useSelector(
    state => state.submissionDetail
  );
  const [value, setValue] = useState(RichTextEditor.createEmptyValue());

  const changeRte = value => {
    setValue(value);
  };

  const sendManualMessage = async value => {
    const content = value
      .toString('html')
      .replace(/<strong>/g, '<b>')
      .replace(/<\/strong>/g, '</b>');

    const submitResult = await dispatch(
      sendMessage({
        content,
        keycloakId: userDetails?.userId,
        submission: submissionId,
      })
    );
    const sendSuccessful = sendMessage.fulfilled.match(submitResult);

    if (sendSuccessful) {
      dispatch(getSubmission(submissionId));
      setValue(RichTextEditor.createEmptyValue());
    }
  };

  const hasValue = !!value
    .getEditorState()
    .getCurrentContent()
    .getPlainText()
    .trim();

  const customControls = [
    () => (
      <Button
        style={{ float: 'right' }}
        size="small"
        onClick={() => sendManualMessage(value)}
        disabled={!hasValue || sendMessageSubmitting}
      >
        {t('datagate.external.submissionDetail.button.sendMessage')}
      </Button>
    ),
  ];

  return (
    <RichTextEditor
      value={value}
      onChange={changeRte}
      toolbarConfig={editorConfig}
      customControls={customControls}
      className="rich-text-editor"
    />
  );
};
